<template>
  <v-dialog v-model="dialog" width="550" scrollable>
    <v-card v-if="dialog">
      <v-card-title>
        <span v-if="loading">Aguarde...</span>
        <div v-else>
          Boletos da fatura {{ fatura.documento }}
          <br />
          <span class="subtitle-1">Cliente: {{ ordem.clientes.id }} - {{ ordem.clientes.nome }}</span>
        </div>
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-0">
        <template v-if="loading">
          <v-skeleton-loader type="list-item-three-line" />
          <v-skeleton-loader type="list-item-three-line" />
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">CANCELAR</v-btn>
        <v-btn color="primary" depressed @click="visualizar()" :disabled="disabled">
          <v-icon class="mr-2">mdi-eye-outline</v-icon>VISUALIZAR
        </v-btn>
        <seletor-email
          tipo-entidade="clientes"
          :id-entidade="ordem.id_cliente"
          tipo-padrao="financeiro"
          @confirmar="enviarEmail($event)"
        >
          <v-btn color="secondary" depressed :disabled="disabled || enviandoEmail" class="ml-2">
            <v-icon class="mr-2">mdi-email-send-outline</v-icon>
            {{ enviandoEmail ? "ENVIANDO" : "ENVIAR EMAIL" }}
          </v-btn>
        </seletor-email>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import number_format from "../../lib/number_format";
import SeletorEmail from "../contatos/SeletorEmail";
export default {
  components: { SeletorEmail },
  data() {
    return {
      loading: true,
      enviandoEmail: false,
      fatura: null,
      incluirFatura: true,
      boletosSelecionados: [],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.boleto.seletor.ordemAtiva !== null;
      },
      set(val) {
        if (!val) {
          this.$store.commit("boleto/setOrdemAtivaSeletor", null);
        }
      },
    },
    disabled() {
      return (
        this.loading ||
        (this.boletosSelecionados.length === 0 && !this.incluirFatura)
      );
    },
    ...mapState({
      ordem: (state) => state.boleto.seletor.ordemAtiva,
    }),
  },
  methods: {
    async carregarFatura() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch(
          "contasReceber/carregarContasReceber",
          this.ordem.id
        );
        this.fatura = response.data;

        this.boletosSelecionados = this.fatura;
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a fatura",
        });
      }
      this.loading = false;
    },
    vencimento(cr) {
      return moment(cr.data_vencimento).format("DD/MM/YYYY");
    },
    valor(cr) {
      return number_format(cr.valor_receber);
    },
    async gerarImpressoes() {
      const p = [];
      console.log(this.boletosSelecionados);
      //for (let cr of this.boletosSelecionados) {
      p.push(
        this.$store.dispatch("boleto/arquivoBoleto", this.boletosSelecionados.id)
      );
      //}
      try {
        const impressoes = await Promise.all(p);
        return Promise.resolve(impressoes);
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível recuperar os boletos",
        });
        return Promise.reject(err);
      }
    },
    visualizar() {
      this.gerarImpressoes().then((impressoes) => {
        for (let impressao of impressoes.reverse()) {
          const url = window.URL.createObjectURL(
            new Blob([impressao], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 3000);
          link.remove();
        }
      });
    },
    async enviarEmail(emails) {
      this.enviandoEmail = true;
      try {
        const impressoes = await this.gerarImpressoes();
        const payload = new FormData();

        for (let i = 0; i < impressoes.length; i++) {
          let documento = this.boletosSelecionados.documento;
          const parts = documento.split("/");
          documento = `${parts[0]}-${parts[1]}`;
          const arquivo = new File([impressoes[i]], `boleto-${documento}.pdf`, {
            type: "application/pdf",
          });
          payload.append("arquivos", arquivo);
        }

        payload.append("emails", emails.join(","));

        await this.$store.dispatch("email/boletos", {
          id_fatura: this.fatura.id,
          payload,
        });
        this.dialog = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Email enviado com sucesso",
          color: "success",
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível enviar o email ao cliente",
        });
      }
      this.enviandoEmail = false;
    },
  },
  watch: {
    dialog(val) {
      this.boletosSelecionados = [];
      if (!val) {
        return;
      }

      this.carregarFatura();
    },
  },
};
</script>
